import { useEffect } from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import { TextHead, TextRegular, Button } from "./InitialRegistPopup.styled";
import { useNavigate } from "react-router-dom";
import { usePageContextFunction } from "../../../../context/PageContext";
import moment from "moment";
import { capitalizeFLetter, formatRupiah } from "../../../../utils/function";
import { useFetchEventCategory, useGetPaymentDetails } from "../../../../networks";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const InitialRegistPopup = ({
  city,
  data,
  registStartDate,
  registEndDate,
  registAnnounceDate,
  selectedForm,
}) => {
  const { size } = useWindowSize();
  const navigate = useNavigate();
  const { setOpenPopUp: tooglePopUp } = usePageContextFunction();
  const isMobileView = (size?.width || 0) <= 768;
  const schoolCategory = data?.category;
  const competition = data?.competition;
  const cityId = data?.cityId;
  const kota = city.charAt(0).toUpperCase() + city.slice(1);
  const regionName = data?.regionName || kota;

  const currentYears = moment()?.year();

  // Biaya diambil per region kota yang dipilih user. cityId ini region id yang
  // sama yang dipakai buat :region_id di URL form pendaftaran di bawah.
  const { data: dataPaymentDetailRaw } = useGetPaymentDetails(cityId, !!cityId);
  const smpFee = dataPaymentDetailRaw?.data?.data?.smp_fee;
  const smaFee = dataPaymentDetailRaw?.data?.data?.sma_fee;
  const kampusFee = dataPaymentDetailRaw?.data?.data?.kampus_fee;

  const { data: dataEventCategoryRaw, isFetching: fetchingEventCategory } =
    useFetchEventCategory();
  const dataEventCategories = dataEventCategoryRaw?.data?.data?.event_categories || [];
  const categoryName = competition === "Futsal" ? `Futsal ${schoolCategory}` : competition;
  // Dicocokin case-insensitive: schoolCategory dari UI itu huruf besar semua
  // ("KAMPUS"), sedangkan API ngirim "Futsal Kampus". Kebetulan SMP/SMA lolos
  // karena kapitalisasinya kebetulan sama. Pola lowercase ini sama dengan yang
  // dipakai RegistrationPage dan CityListModal.
  const competititonId = dataEventCategories?.find(
    (data) => data?.category_name?.toLowerCase() === categoryName?.toLowerCase(),
  )?.id;

  moment.locale("id");

  const formattedStartDate = moment(registStartDate).format("D MMMM");
  const formattedEndDate = moment(registEndDate).format("D MMMM YYYY");
  const formattedAnnoucementDate = moment(registAnnounceDate).format("D MMMM YYYY");

  // Tanpa id kategori, URL form-nya bakal berisi "undefined" dan user baru
  // kena error setelah ngisi seluruh formulir. Lebih baik ditahan di sini.
  const isCategoryReady = !!competititonId;
  // Popup ini juga bisa dibuka dari tombol "Info Registrasi" di navbar sebelum
  // user milih kategori sekolah. Di situ isinya murni informatif, jadi jangan
  // nuduh kategorinya "belum tersedia" — tombol lanjutnya udah ke-disable
  // sebagai fallback. Dance ga butuh kategori sekolah buat nyari id-nya.
  const isCategorySelected = competition === "Dance" || !!schoolCategory;

  const handleRegistrationFlow = () => {
    if (!isCategoryReady) return;

    if (competition === "Dance") {
      // For Dance category
      navigate(`/${city}/registrasi/form-dance/${schoolCategory}/${cityId}/${competititonId}`, {
        state: {
          preserveCategory: true,
          category: schoolCategory,
        },
      });
    } else {
      // For Futsal category
      navigate(`/${city}/registrasi/form/${schoolCategory}/${cityId}/${competititonId}`, {
        state: {
          preserveCategory: true,
          category: schoolCategory,
        },
      });
    }
    tooglePopUp(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <TextHead>
        Registrasi Piala by.U {regionName} {currentYears}
      </TextHead>
      <TextRegular>
        {competition === "Dance"
          ? `Dance Competition ini dikhususkan untuk kategori SMA/Sederajat. Periode registrasi dibuka pada tanggal ${formattedStartDate} hingga ${formattedEndDate}.`
          : `Calon peserta Piala by.U ${regionName} ${currentYears} harap mengisi
        form registrasi awal berikut. Periode registrasi Piala by.U ${kota}
        dibuka dari tanggal ${formattedStartDate} hingga ${formattedEndDate}.
        Semua data isian menjadi hak panitia penyelenggara sebagai acuan untuk
        memilih peserta. Pengumuman peserta piala by.U ${kota} yakni tanggal
        ${formattedAnnoucementDate}.`}
      </TextRegular>
      {competition === "Dance" ? (
        <TextRegular fontSize={isMobileView ? "14px" : "18px"}>
          <b style={{ whiteSpace: "pre" }}>
            {isMobileView
              ? `10 Peserta yang terpilih akan dihubungi\npanitia dan membayar biaya registrasi\nsebesar Rp100.000,- `
              : `10 Peserta yang terpilih akan dihubungi panitia dan membayar biaya registrasi\nsebesar Rp100.000,- `}
          </b>
        </TextRegular>
      ) : (
        // Figma: Gilroy Bold Italic. Children inherit both from here.
        <div className="text-[#1F2D3D] italic font-bold">
          <p className="text-[16px] leading-[24px] m-0">
            Peserta yang terpilih akan dihubungi panitia dan membayar biaya registrasi sebesar:
          </p>
          <ul className="list-disc pl-[20px] m-0">
            {smpFee != null && (
              <li className="text-[14px] leading-[24px]">
                Kategori SMP/Sederajat: {formatRupiah(smpFee)},-
              </li>
            )}
            {smaFee != null && (
              <li className="text-[14px] leading-[24px]">
                Kategori SMA/Sederajat: {formatRupiah(smaFee)},-
              </li>
            )}
            {kampusFee != null && (
              <li className="text-[14px] leading-[24px]">
                Kategori Kuliah: {formatRupiah(kampusFee)},-
              </li>
            )}
          </ul>
        </div>
      )}
      <TextRegular>
        Informasi lebih lanjut, kamu bisa menghubungi contact center kami:
        <b>
          <br />
          085117354898 (WA Saja)
        </b>
      </TextRegular>
      {/* Bootstrap also ships a `.border` class whose !important rules beat
          Tailwind's (and even inline styles), so the width uses the
          arbitrary-value `border-[1px]` instead of the bare `border`. */}
      <div className="flex gap-x-[8px] items-center p-[8px] rounded-[8px] border-[1px] border-[#FFBC00] bg-[#FFF2DB]">
        <img
          src={func.getStaticImg("icon/sa-warning.svg")}
          alt=""
          className="w-[16px] h-[16px] shrink-0"
        />
        <p className="text-[11px] leading-[13px] text-[#6A7481] m-0">
          Seluruh pemain & koordinator suporter WAJIB menggunakan kartu by.U atau Telkomsel sebagai
          syarat menjadi peserta Piala by.U {currentYears}
        </p>
      </div>
      {isCategorySelected && !isCategoryReady && !fetchingEventCategory && (
        <p className="text-[12px] leading-[16px] text-red-600 m-0">
          Kategori {categoryName} belum tersedia untuk saat ini. Coba pilih kategori lain atau
          hubungi contact center di atas.
        </p>
      )}
      <Button
        onClick={handleRegistrationFlow}
        disabled={!isCategoryReady}
        style={!isCategoryReady ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
      >
        Siap, lanjut registrasi
      </Button>
    </div>
  );
};

export default InitialRegistPopup;
